<template>
  <div
    class="pw-player-playBtn-holder player-adon"
    @click="play"
    v-if="isPosterVisible.value"
  >
    <div>
      <svg
        class="shaka-big-play"
        viewBox="0 0 61 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="61"
          height="61"
          rx="12"
          class="shaka-play-button-color"
          fill-opacity="0.8"
        />
        <path
          class="shaka-play-button-contrast"
          d="M22 21.5763C22 19.5799 24.1634 18.3445 25.8688 19.367L40.752 28.2906C42.416 29.2884 42.416 31.7115 40.752 32.7092L25.8688 41.633C24.1635 42.6555 22 41.4201 22 39.4237L22 21.5763Z"
        />
      </svg>
    </div>
    <div
      class="parmonic-video-duration"
      ref="duration"
      v-html="totalDuration"
      v-if="totalDuration"
    ></div>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType, Ref } from "vue"

export default defineComponent({
  props: {
    play: { type: Function, required: true },
    isPosterVisible: {
      type: Object as PropType<Ref<Boolean>>,
      required: true
    },
    totalDuration: { type: String, required: false }
  }
})
</script>
